import type { AutomationCurve } from './types';

/**
 * The shape of one segment between two points.
 *
 * Every curve in the project — automation lanes, clip gain envelopes — is drawn
 * between two points with one of these shapes, so the shape lives here rather
 * than beside any one of them. `t` is the position along the segment in 0..1;
 * the result is how far the value has travelled from the first point to the
 * second, also 0..1.
 */
export function curveShape(curve: AutomationCurve, t: number): number {
  const x = t < 0 ? 0 : t > 1 ? 1 : t;
  switch (curve) {
    case 'hold':
      return 0;
    case 'smooth':
      // Smoothstep: zero slope at both ends, so joined segments have no corner.
      return x * x * (3 - 2 * x);
    case 'linear':
    default:
      return x;
  }
}
